import { API } from 'src/helpers/api';
import { BOT_ID } from 'src/config-global';
import { ActionType, ActionTypes } from 'src/contexts/AppContext';

export const getAllUsers = async (dispatch: React.Dispatch<ActionType>, userIds?: string[]) => {
  try {
    const { data } = await API({
      url: 'sso/user/all',
      method: 'GET',
      params: !userIds ? { botId: BOT_ID } : { botId: BOT_ID, userIds },
    });
    if (dispatch) {
      dispatch({
        type: ActionTypes.GET_ALL_USERS,
        payload: { users: data },
      });
    }
    return data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
